export default __webpack_public_path__ + "d982732a89d90dfac2ce73ce599e1ec5.png";